var map = {
	"./bigball/BigBall_000.png": 895,
	"./bigball/BigBall_001.png": 896,
	"./bigball/BigBall_002.png": 897,
	"./bigball/BigBall_003.png": 898,
	"./bigball/BigBall_004.png": 899,
	"./bigball/BigBall_005.png": 900,
	"./bigball/BigBall_006.png": 901,
	"./bigball/BigBall_007.png": 902,
	"./bigball/BigBall_008.png": 903,
	"./bigball/BigBall_009.png": 904,
	"./bigball/BigBall_010.png": 905,
	"./bigball/BigBall_011.png": 906,
	"./bigball/BigBall_012.png": 907,
	"./bigball/BigBall_013.png": 908,
	"./bigball/BigBall_014.png": 909,
	"./bigball/BigBall_015.png": 910,
	"./bigball/BigBall_016.png": 911,
	"./bigball/BigBall_017.png": 912,
	"./bigball/BigBall_018.png": 913,
	"./bigball/BigBall_019.png": 914,
	"./bigball/BigBall_020.png": 915,
	"./bigball/BigBall_021.png": 916,
	"./bigball/BigBall_022.png": 917,
	"./bigball/BigBall_023.png": 918,
	"./bigball/BigBall_024.png": 919,
	"./bigball/BigBall_025.png": 920,
	"./black-ball.png": 94,
	"./blue-ball.png": 95,
	"./bonus_green/background.png": 921,
	"./bonus_green/ball_holder.png": 922,
	"./bonus_green/check_infoBar/check_000.png": 923,
	"./bonus_green/check_infoBar/check_001.png": 924,
	"./bonus_green/check_infoBar/check_002.png": 925,
	"./bonus_green/check_infoBar/check_003.png": 926,
	"./bonus_green/check_infoBar/check_004.png": 927,
	"./bonus_green/check_infoBar/check_005.png": 928,
	"./bonus_green/check_infoBar/check_006.png": 929,
	"./bonus_green/check_infoBar/check_007.png": 930,
	"./bonus_green/check_infoBar/check_008.png": 931,
	"./bonus_green/check_infoBar/check_009.png": 932,
	"./bonus_green/check_infoBar/check_010.png": 933,
	"./bonus_green/check_infoBar/check_011.png": 934,
	"./bonus_green/check_infoBar/check_012.png": 935,
	"./bonus_green/check_infoBar/check_013.png": 936,
	"./bonus_green/check_infoBar/check_014.png": 937,
	"./bonus_green/check_infoBar/check_015.png": 938,
	"./bonus_green/footer.png": 939,
	"./bonus_green/header.png": 940,
	"./bonus_green/hole.png": 941,
	"./bonus_green/number_picked.png": 942,
	"./bonus_yellow/background.png": 943,
	"./bonus_yellow/ball_holder.png": 944,
	"./bonus_yellow/check_infoBar/check_000.png": 945,
	"./bonus_yellow/check_infoBar/check_001.png": 946,
	"./bonus_yellow/check_infoBar/check_002.png": 947,
	"./bonus_yellow/check_infoBar/check_003.png": 948,
	"./bonus_yellow/check_infoBar/check_004.png": 949,
	"./bonus_yellow/check_infoBar/check_005.png": 950,
	"./bonus_yellow/check_infoBar/check_006.png": 951,
	"./bonus_yellow/check_infoBar/check_007.png": 952,
	"./bonus_yellow/check_infoBar/check_008.png": 953,
	"./bonus_yellow/check_infoBar/check_009.png": 954,
	"./bonus_yellow/check_infoBar/check_010.png": 955,
	"./bonus_yellow/check_infoBar/check_011.png": 956,
	"./bonus_yellow/check_infoBar/check_012.png": 957,
	"./bonus_yellow/check_infoBar/check_013.png": 958,
	"./bonus_yellow/check_infoBar/check_014.png": 959,
	"./bonus_yellow/check_infoBar/check_015.png": 960,
	"./bonus_yellow/footer.png": 961,
	"./bonus_yellow/header.png": 962,
	"./bonus_yellow/header_betin.png": 963,
	"./bonus_yellow/header_betole.png": 964,
	"./bonus_yellow/header_dualsoft.png": 965,
	"./bonus_yellow/header_elbet.png": 966,
	"./bonus_yellow/header_maxbet.png": 967,
	"./bonus_yellow/header_oktagon.png": 968,
	"./bonus_yellow/header_pinnbet.png": 969,
	"./bonus_yellow/header_soccer.png": 970,
	"./bonus_yellow/header_surebet247.png": 971,
	"./bonus_yellow/header_winbet.png": 972,
	"./bonus_yellow/hole.png": 973,
	"./bonus_yellow/number_picked.png": 974,
	"./brown-ball.png": 96,
	"./btn-background-black.png": 97,
	"./btn-background-green.png": 98,
	"./colorBetting.png": 975,
	"./color_betting/black.png": 976,
	"./color_betting/blue.png": 977,
	"./color_betting/brown.png": 978,
	"./color_betting/green.png": 979,
	"./color_betting/orange.png": 980,
	"./color_betting/purple.png": 981,
	"./color_betting/red.png": 982,
	"./color_betting/yellow.png": 983,
	"./combos-sr/201-.png": 984,
	"./combos-sr/201.png": 985,
	"./combos-sr/210-.png": 986,
	"./combos-sr/210.png": 987,
	"./combos-sr/28-.png": 988,
	"./combos-sr/28.png": 989,
	"./combos-sr/6-.png": 990,
	"./combos-sr/6.png": 991,
	"./combos-sr/7-.png": 992,
	"./combos-sr/7.png": 993,
	"./combos-sr/81-.png": 994,
	"./combos-sr/81.png": 995,
	"./combos-sr/84-.png": 996,
	"./combos-sr/84.png": 997,
	"./combos/201-.png": 998,
	"./combos/201.png": 999,
	"./combos/210-.png": 1000,
	"./combos/210.png": 227,
	"./combos/28-.png": 1001,
	"./combos/28.png": 228,
	"./combos/6-.png": 1002,
	"./combos/6.png": 1003,
	"./combos/7-.png": 1004,
	"./combos/7.png": 229,
	"./combos/81-.png": 1005,
	"./combos/81.png": 1006,
	"./combos/84-.png": 1007,
	"./combos/84.png": 230,
	"./drawnballs/black.png": 1008,
	"./drawnballs/blue.png": 1009,
	"./drawnballs/brown.png": 1010,
	"./drawnballs/green.png": 1011,
	"./drawnballs/orange.png": 1012,
	"./drawnballs/purple.png": 1013,
	"./drawnballs/red.png": 1014,
	"./drawnballs/yellow.png": 1015,
	"./drum/drum_loop_001.png": 1016,
	"./drum/drum_loop_002.png": 1017,
	"./drum/drum_loop_003.png": 1018,
	"./drum/drum_loop_004.png": 1019,
	"./drum/drum_loop_005.png": 1020,
	"./drum/drum_loop_006.png": 1021,
	"./drum/drum_loop_007.png": 1022,
	"./drum/drum_loop_008.png": 1023,
	"./drum/drum_loop_009.png": 1024,
	"./drum/drum_loop_010.png": 1025,
	"./drum/drum_loop_011.png": 1026,
	"./drum/drum_loop_012.png": 1027,
	"./drum/drum_loop_013.png": 1028,
	"./drum/drum_loop_014.png": 1029,
	"./drum/drum_loop_015.png": 1030,
	"./drum/drum_loop_016.png": 1031,
	"./drum/drum_loop_017.png": 1032,
	"./drum/drum_loop_018.png": 1033,
	"./drum/drum_loop_019.png": 1034,
	"./drum/drum_loop_020.png": 1035,
	"./drum/drum_loop_021.png": 1036,
	"./drum/drum_loop_022.png": 1037,
	"./drum/drum_loop_023.png": 1038,
	"./drum/drum_loop_024.png": 1039,
	"./drum/drum_loop_025.png": 1040,
	"./drum/drum_loop_026.png": 1041,
	"./drum/drum_loop_027.png": 1042,
	"./drum/drum_loop_028.png": 1043,
	"./drum/drum_loop_029.png": 1044,
	"./drum/drum_loop_030.png": 1045,
	"./drum/drum_loop_031.png": 1046,
	"./drum/drum_loop_032.png": 1047,
	"./drum/drum_loop_033.png": 1048,
	"./drum/drum_loop_034.png": 1049,
	"./drum/drum_loop_035.png": 1050,
	"./drum/drum_loop_036.png": 1051,
	"./drum/drum_loop_037.png": 1052,
	"./drum/drum_loop_038.png": 1053,
	"./drum/drum_loop_039.png": 1054,
	"./drum/drum_loop_040.png": 1055,
	"./drum/drum_loop_041.png": 1056,
	"./drum/drum_loop_042.png": 1057,
	"./drum/frame.png": 1058,
	"./fast-arrow-down.png": 231,
	"./fast-arrow-right.png": 232,
	"./fast-choosen-bck.png": 160,
	"./flower.png": 1059,
	"./green-ball.png": 99,
	"./header-babaijebu.png": 233,
	"./header-intro.png": 1060,
	"./icons/192.png": 1061,
	"./icons/512.png": 1062,
	"./icons/96.png": 1063,
	"./icons/favicon.png": 1064,
	"./infobox/info_Box_000.png": 1065,
	"./infobox/info_Box_001.png": 1066,
	"./infobox/info_Box_002.png": 1067,
	"./infobox/info_Box_003.png": 1068,
	"./infobox/info_Box_004.png": 1069,
	"./infobox/info_Box_005.png": 1070,
	"./infobox/info_Box_006.png": 1071,
	"./infobox/info_Box_007.png": 1072,
	"./infobox/info_Box_008.png": 1073,
	"./infobox/info_Box_009.png": 1074,
	"./infobox/info_Box_010.png": 1075,
	"./infobox/info_Box_011.png": 1076,
	"./infobox/info_Box_012.png": 1077,
	"./infobox/info_Box_013.png": 1078,
	"./infobox/info_Box_014.png": 1079,
	"./infobox/info_Box_015.png": 1080,
	"./infobox/info_Box_016.png": 1081,
	"./infobox/info_Box_017.png": 1082,
	"./infobox/info_Box_018.png": 1083,
	"./infobox/info_Box_019.png": 1084,
	"./infobox/info_Box_020.png": 1085,
	"./infobox/info_Box_021.png": 1086,
	"./infobox/info_Box_022.png": 1087,
	"./infobox/info_Box_023.png": 1088,
	"./infobox/info_Box_024.png": 1089,
	"./infobox/info_Box_025.png": 1090,
	"./infobox/info_Box_026.png": 1091,
	"./infobox/info_Box_027.png": 1092,
	"./infobox/info_Box_028.png": 1093,
	"./infobox/info_Box_029.png": 1094,
	"./infobox/info_Box_030.png": 1095,
	"./infobox/info_Box_031.png": 1096,
	"./infobox/info_Box_032.png": 1097,
	"./infobox/info_Box_033.png": 1098,
	"./infobox/info_Box_034.png": 1099,
	"./intro.jpg": 1100,
	"./jackpot/001.png": 1101,
	"./jackpot/002.png": 1102,
	"./jackpot/003.png": 1103,
	"./jackpot/004.png": 1104,
	"./jackpot/005.png": 1105,
	"./jackpot/006.png": 1106,
	"./jackpot/007.png": 1107,
	"./jackpot/008.png": 1108,
	"./jackpot/009.png": 1109,
	"./jackpot/010.png": 1110,
	"./jackpot/011.png": 1111,
	"./jackpot/012.png": 1112,
	"./jackpot/013.png": 1113,
	"./jackpot/014.png": 1114,
	"./jackpot/015.png": 1115,
	"./jackpot/016.png": 1116,
	"./jackpot/017.png": 1117,
	"./jackpot/018.png": 1118,
	"./jackpot/019.png": 1119,
	"./kvacica.png": 100,
	"./loader-1.png": 1120,
	"./loading.png": 1121,
	"./orange-ball.png": 101,
	"./purple-ball.png": 102,
	"./red-ball.png": 103,
	"./regular_game/background.png": 1122,
	"./regular_game/ball_holder.png": 1123,
	"./regular_game/check_infoBar/check_000.png": 1124,
	"./regular_game/check_infoBar/check_001.png": 1125,
	"./regular_game/check_infoBar/check_002.png": 1126,
	"./regular_game/check_infoBar/check_003.png": 1127,
	"./regular_game/check_infoBar/check_004.png": 1128,
	"./regular_game/check_infoBar/check_005.png": 1129,
	"./regular_game/check_infoBar/check_006.png": 1130,
	"./regular_game/check_infoBar/check_007.png": 1131,
	"./regular_game/check_infoBar/check_008.png": 1132,
	"./regular_game/check_infoBar/check_009.png": 1133,
	"./regular_game/check_infoBar/check_010.png": 1134,
	"./regular_game/check_infoBar/check_011.png": 1135,
	"./regular_game/check_infoBar/check_012.png": 1136,
	"./regular_game/check_infoBar/check_013.png": 1137,
	"./regular_game/check_infoBar/check_014.png": 1138,
	"./regular_game/check_infoBar/check_015.png": 1139,
	"./regular_game/footer.png": 1140,
	"./regular_game/header.png": 1141,
	"./regular_game/header_betin.png": 1142,
	"./regular_game/header_betole.png": 1143,
	"./regular_game/header_dualsoft.png": 1144,
	"./regular_game/header_elbet.png": 1145,
	"./regular_game/header_maxbet.png": 1146,
	"./regular_game/header_oktagon.png": 1147,
	"./regular_game/header_pinnbet.png": 1148,
	"./regular_game/header_soccer.png": 1149,
	"./regular_game/header_surebet247.png": 1150,
	"./regular_game/header_winbet.png": 1151,
	"./regular_game/hole.png": 1152,
	"./regular_game/number_picked.png": 1153,
	"./risk.png": 1154,
	"./video.png": 1155,
	"./weager/Background_image.png": 1156,
	"./weager/Button.png": 1157,
	"./weager/Button_pressed.png": 1158,
	"./weager/Buy_Ticket.png": 1159,
	"./weager/Buy_Ticket_pressed.png": 1160,
	"./weager/Lower_Raise/Button_Higher.png": 1161,
	"./weager/Lower_Raise/Button_Higher_minus.png": 1162,
	"./weager/Lower_Raise/Button_Higher_plus.png": 1163,
	"./weager/Lower_Raise/Button_Higher_pressed.png": 1164,
	"./weager/Lower_Raise/Button_Lower.png": 1165,
	"./weager/Lower_Raise/Button_Lower_pressed.png": 1166,
	"./weager/Lower_Raise/Value_Holder.png": 1167,
	"./weager/Page_left.png": 1168,
	"./weager/Page_right.png": 1169,
	"./weager/Repeat.png": 1170,
	"./weager/Shuffle.png": 1171,
	"./weager/Stake_Holder.png": 1172,
	"./weager/Tab_normal.png": 1173,
	"./weager/Tab_pressed.png": 1174,
	"./weager/ball-chosen-holder.png": 1175,
	"./weager/balls/color/black.png": 1176,
	"./weager/balls/color/blue.png": 1177,
	"./weager/balls/color/brown.png": 1178,
	"./weager/balls/color/green.png": 1179,
	"./weager/balls/color/orange.png": 1180,
	"./weager/balls/color/purple.png": 1181,
	"./weager/balls/color/red.png": 1182,
	"./weager/balls/color/yellow.png": 1183,
	"./weager/balls/normal/LB_1.png": 1184,
	"./weager/balls/normal/LB_2.png": 1185,
	"./weager/balls/normal/LB_3.png": 1186,
	"./weager/balls/normal/LB_4.png": 1187,
	"./weager/balls/normal/LB_5.png": 1188,
	"./weager/balls/normal/LB_6.png": 1189,
	"./weager/balls/normal/LB_7.png": 1190,
	"./weager/balls/normal/LB_8.png": 1191,
	"./yellow-ball.png": 104
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 894;


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img \.(gif|png|jpe?g|svg)$/
// module id = 894
// module chunks = 0